import React from 'react';
import { classNames, surfaceClassNames, SurfaceClassNameProps } from './classNames';

export interface ListGroupItemProps
  extends React.HTMLAttributes<HTMLElement>,
    SurfaceClassNameProps {
  as?: React.ElementType;
}

const ListGroupItem: React.FC<ListGroupItemProps> = ({
  as: Component = 'div',
  background,
  bordered,
  borderless,
  borderColor,
  className,
  children,
  rounded,
  shadow,
  ...props
}) => (
  <Component
    className={classNames(
      'list-group-item',
      surfaceClassNames({
        background,
        bordered,
        borderless,
        borderColor,
        rounded,
        shadow,
      }),
      className,
    )}
    {...props}
  >
    {children}
  </Component>
);

export default ListGroupItem;
